import { oktaAuth } from '../config/OktaConfig'

const url = process.env.REACT_APP_SHIPMENT_TRACKING_API_URL + '/usage-log'

export function logUsage(page: string, action: string, params = {}) {
  fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      authorization: `Bearer ${oktaAuth.getAccessToken() || ''}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ page, action, ...params }),
  }).catch(console.error)
}
